// extracted by mini-css-extract-plugin
module.exports = {"Popover":"Popover_Popover__3UrwZ","title":"Popover_title__2Qp4I","arrow":"Popover_arrow__lgrE-","inner":"Popover_inner__1UtRM"};